export class TenantCache {
    static get tenantCache() {
        return TenantCache._tenantCache;
    }
    static set tenantCache(value) {
        TenantCache._tenantCache = value;
    }
}
Object.defineProperty(TenantCache, "_tenantCache", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: {}
});
//# sourceMappingURL=TenantCache.js.map